import { render, staticRenderFns } from "./DataConfig.vue?vue&type=template&id=44d0b0ad"
import script from "./DataConfig.vue?vue&type=script&lang=js"
export * from "./DataConfig.vue?vue&type=script&lang=js"
import style0 from "./DataConfig.vue?vue&type=style&index=0&id=44d0b0ad&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports